import { useState, useEffect } from 'react'

const API_URL = process.env.REACT_APP_CRM_API_URL || 'http://localhost:5000/api/crm'

export function useTeamUnread(sellerId) {
  const [totalUnread, setTotalUnread] = useState(0)
  const [byChannel, setByChannel] = useState({})

  useEffect(() => {
    if (!sellerId) return

    const fetchUnread = async () => {
      try {
        const res = await fetch(`${API_URL}/team/unread?seller_id=${sellerId}`)
        if (!res.ok) return
        const data = await res.json()
        setTotalUnread(data.total || 0)
        setByChannel(data.by_channel || {})
      } catch {
        setTotalUnread(0)
        setByChannel({})
      }
    }

    fetchUnread()
    const interval = setInterval(fetchUnread, 30000)
    return () => clearInterval(interval)
  }, [sellerId])

  return { totalUnread, byChannel }
}
